namespace RedBullMOBILE360.CVM {
    export interface CvmCampaignForm {
        Name: Serenity.StringEditor;
        Duration: Serenity.IntegerEditor;
        NextRun: Serenity.DateEditor;
    }

    export class CvmCampaignForm extends Serenity.PrefixedContext {
        static formKey = 'CVM.CvmCampaign';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CvmCampaignForm.init)  {
                CvmCampaignForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;

                Q.initFormType(CvmCampaignForm, [
                    'Name', w0,
                    'Duration', w1,
                    'NextRun', w2
                ]);
            }
        }
    }
}
